import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, LucideIcon } from "lucide-react";
import { CTA } from "./CTA";

interface ServiceCardProps {
  icon: LucideIcon;
  title: string;
  description: string;
  path: string;
  index?: number;
}

export default function ServiceCard({ icon: Icon, title, description, path, index = 0 }: ServiceCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
    >
      <Link
        to={path}
        className="group flex h-full flex-col rounded-xl border border-border bg-card p-6 transition-all duration-300 hover:-translate-y-1 hover:border-accent hover:shadow-lg"
      >
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-accent/10 text-accent transition-colors group-hover:bg-accent group-hover:text-accent-foreground">
          <Icon className="h-6 w-6" />
        </div>
        <h3 className="mb-2 font-heading text-lg font-semibold text-card-foreground">{title}</h3>
        <p className="mb-4 flex-1 text-sm leading-relaxed text-muted-foreground">{description}</p>
        <CTA variant="tertiary" to={path}>
          Learn more
        </CTA>
      </Link>
    </motion.div>
  );
}
